export default __webpack_public_path__ + "static/media/add-valve.f82b924d.svg";